// بدّل أو أضف هذه الـ imports
import { Autocomplete, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// --- داخل ملف QuestionsTable (قبل return) أضف هذا المكوّن الداخلي ---
export const FilterSelectSearch = ({
    id,
    label,
    value,        // هنا نتوقع id (string|number) كما في الـ Select القديم
    onChange,     // onChange يستقبل id جديد أو "" لإلغاء الاختيار
    options = [], // [{ id, name }, ...]
    disabled = false,
    clearable = true, // لو تريد زر مسح الخيار
}) => {
    const theme = useTheme();

    // نحول id -> كائن الخيار لكي يشتغل Autocomplete مع value الصحيح
    const selectedOption = options.find((o) => String(o.id) === String(value)) ?? null;

    return (
        <Autocomplete
            id={`${id}-autocomplete`}
            options={options}
            value={selectedOption}
            onChange={(_, newVal) => {
                // نعيد فقط الـ id مثل الـ Select القديم
                onChange(newVal ? newVal.id : "");
            }}
            getOptionLabel={(opt) => opt?.name ?? ""}
            isOptionEqualToValue={(option, val) => String(option?.id) === String(val?.id ?? val ?? "")}
            disabled={disabled}
            size="small"
            fullWidth
            disableClearable={!clearable}
            clearOnEscape
            ListboxProps={{ sx: { maxHeight: 320 } }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    size="small"
                    InputProps={{
                        ...params.InputProps,
                        sx: {
                            height: 40,
                            backgroundColor: theme.palette.background.input,
                            borderRadius: 1,
                            // نجعل النص محاذي بشكل جيد داخل الحقل
                            "& input": {
                                paddingLeft: 8,
                                paddingRight: 8,
                            },
                        },
                    }}
                />
            )}
            sx={{
                // تخفيف الفوارق بين شكل الـ Select القديم و الـ Autocomplete
                '& .MuiAutocomplete-inputRoot': {
                    paddingRight: 1,
                    minHeight: 40,
                },
                // '& .MuiAutocomplete-clearIndicator': {
                //     right: 36,
                // }
            }}
        />
    );
};
